import angular from 'angular';
import StorageFactory from './storage.factory';

let storageModule = angular.module('store', [])

    .factory('Store', StorageFactory)

    .name;

export default storageModule;


// WEBPACK FOOTER //
// ./client/app/common/storage/index.js